<template>
  <div class="q-mt-lg">
    <p class="texto-titulo text-h6">
      <span class="text-weight-bold">{{ quantidade }}</span> {{ title }}
    </p>
    <div
      v-if="requisicao != 'deletados' && requisicao != 'finalizado'"
      class="row q-mb-lg justify-between"
    >
      <div class="btn-container">
        <q-btn
          class="respI"
          v-if="requisicao != 'finalizacao'"
          no-caps
          color="positive"
          icon="done"
          style="border-radius: 8px"
          :label="
            requisicao != 'deletados' &&
            requisicao != 'finalizado' &&
            requisicao != 'finalizacao'
              ? 'Aprovar Selecionados'
              : 'Finalizar Selecionados'
          "
          :disable="selecionados.length == 0"
          @click="aprovarTodasDialog = !aprovarTodasDialog"
        />
        <q-btn
          class="respI q-ml-md"
          style="border-radius: 8px"
          no-caps
          color="red"
          icon="close"
          label="Rejeitar Selecionados"
          :disable="selecionados.length == 0"
          @click="rejeitarTodasDialog = !rejeitarTodasDialog"
        />
      </div>
      <div>
        <q-btn
          no-caps
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: 100;
          "
          icon="sym_o_upload"
          label="Exportar"
          @click="exportar()"
        />
      </div>
    </div>
    <q-table
      :grid="$q.screen.lt.sm"
      table-header-class="bg-accent text-width-bold"
      :rows="listaRequisicao"
      :columns="columns"
      :loading="disable"
      dense
      color="primary"
      row-key="name"
      hide-pagination
      class="my-sticky-dynamic"
      flat
      ref="table"
      v-model:pagination="pagination"
      no-data-label="Sem dados"
    >
      <template v-slot:item="props">
        <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
          <div class="row card">
            <div class="col-1 q-mr-sm text-center q-mt-lg">
              <q-checkbox
                v-model="selecionados"
                size="lg"
                :val="props.row.id"
                :disable="
                  requisicao == 'deletados' || requisicao == 'finalizado'
                "
              />
            </div>
            <div class="col">
              <q-card-section class="row text-brand-5 text-grid-table">
                <div class="col-12">
                  <span><strong>ID:</strong> {{ props.row.id }}</span>
                  <span class="q-ml-sm"
                    ><strong>Unidade:</strong>
                    {{
                      props.row.vendor ? props.row.vendor.name : "Sem unidade"
                    }}</span
                  >
                </div>
                <div class="col-12">
                  <span
                    ><strong>Solicitante:</strong>
                    {{
                      props.row.plantiff ? props.row.plantiff.name : ""
                    }}</span
                  >
                </div>
                <div class="col-12">
                  <span style="display: inline-block"
                    ><strong>Status Atual:</strong></span
                  >
                  <div style="display: inline-block">
                    <div
                      v-if="
                        props.row.status == 'Aprovado' ||
                        props.row.status == 'Finalizado'
                      "
                      class="row align items-center"
                      style="width: fit-content; padding: 0px 0px 0px 5px"
                    >
                      <span
                        class="elipse status-elipse-container q-mr-sm bg-positive"
                        style="margin: 0px 4px 0px 0px"
                      />
                      <span style="width: fit-content" class="text-brand-5">
                        {{ props.row.status }}
                      </span>
                    </div>
                    <div
                      v-if="props.row.status == 'Pendente'"
                      class="row align items-center"
                      style="width: fit-content; padding: 0px 0px 0px 5px"
                    >
                      <span
                        class="elipse status-elipse-container q-mr-sm bg-warning"
                        style="margin: 0px 4px 0px 0px"
                      />
                      <span style="width: fit-content" class="text-brand-5">
                        {{ props.row.status }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <strong>Produtos:</strong>
                  <p
                    style="margin: 0px; padding: 0px"
                    v-for="(produto, index) in props.row.products"
                    :key="index"
                  >
                    <strong>Item: </strong
                    >{{ Math.trunc(produto.pivot.amount) }} x
                    <span
                      v-if="
                        produto.contracts[0] &&
                        produto.contracts[0].pivot &&
                        produto.contracts[0].pivot.contract_product_description
                      "
                      >{{ produto.code }} -
                      {{
                        produto.contracts[0].pivot.contract_product_description
                      }}</span
                    >
                  </p>
                </div>
              </q-card-section>
            </div>
            <div class="text-grid-table text-body text-brand-5 q-mt-md q-mr-sm">
              <div>
                <div><strong>Assinatura</strong></div>
                <q-img
                  v-if="props.row.voucher_images.length != 0"
                  :src="props.row.voucher_images[0].url"
                  fit="contain"
                  style="max-width: 30px; height: 45px; margin-left: 13px"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="text-brand-5 btn-grid-container">
                <div v-if="requisicao == 'finalizacao'" class="row">
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Finalizar"
                      :style="
                        props.row.status == 'Aprovado'
                          ? { background: '#189f2e', color: 'white' }
                          : { background: '#A4A4A4', color: 'white' }
                      "
                      icon="sym_o_done_outline"
                      @click="handleFinalizarClick(props.row)"
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Detalhe"
                      style="background: #3c76f1; color: white"
                      icon="sym_o_article"
                      @click="detalharRequisicao(props.row.id)"
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Deletar"
                      style="background: #cf1515; color: white"
                      icon="sym_o_delete"
                      @click="excluir(props.row.id)"
                    />
                  </div>
                  <div class="column col-3">
                    <router-link
                      :to="{
                        name: 'requisicao-imprimir',
                        params: { requisicaoId: props.row.id },
                      }"
                    >
                      <q-btn
                        no-caps
                        stack
                        class="btn-grid-finalizacao"
                        label="Exportar"
                        style="background: #373737; color: white"
                        icon="sym_o_print"
                      />
                    </router-link>
                  </div>
                </div>
                <div v-if="requisicao == 'aprovacao'" class="row">
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Aprovar"
                      style="background: #189f2e; color: white"
                      icon="sym_o_done_outline"
                      @click="
                        (aprovarDialog = !aprovarDialog),
                          (linhaParaAcao = props.row)
                      "
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Detalhe"
                      style="background: #3c76f1; color: white"
                      icon="sym_o_article"
                      @click="detalharRequisicao(props.row.id)"
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Deletar"
                      style="background: #cf1515; color: white"
                      icon="sym_o_delete"
                      @click="excluir(props.row.id)"
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-finalizacao"
                      label="Exportar"
                      style="background: #373737; color: white"
                      icon="sym_o_print"
                      @click="imprimir(props.row.id)"
                    />
                  </div>
                </div>
                <div v-if="requisicao == 'finalizado'" class="row">
                  <div class="column col-3">
                    <q-btn
                      class="btn-grid-deletados"
                      stack
                      no-caps
                      label="Duplicar"
                      style="background: #545454; color: white"
                      icon="content_copy"
                      @click="
                        (duplicarDialog = !duplicarDialog),
                          (linhaParaAcao = props.row)
                      "
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      class="btn-grid-deletados"
                      stack
                      no-caps
                      label="Detalhe"
                      style="background: #3c76f1; color: white"
                      icon="sym_o_article"
                      @click="detalharRequisicao(props.row.id)"
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      class="btn-grid-deletados"
                      stack
                      no-caps
                      label="Deletar"
                      style="background: #cf1515; color: white"
                      icon="sym_o_delete"
                      @click="
                        (deletarDialog = !deletarDialog),
                          (linhaParaAcao = props.row),
                          (isFinalizado = true)
                      "
                    />
                  </div>
                  <div class="column col-3">
                    <q-btn
                      no-caps
                      stack
                      class="btn-grid-deletados"
                      label="Exportar"
                      style="background: #373737; color: white"
                      icon="sym_o_print"
                      @click="imprimir(props.row.id)"
                    />
                  </div>
                </div>
                <div v-if="requisicao == 'deletados'" class="row">
                  <div class="column col-6">
                    <q-btn
                      class="btn-grid-deletados"
                      stack
                      no-caps
                      label="Detalhe"
                      style="background: #3c76f1; color: white"
                      icon="sym_o_article"
                    />
                  </div>

                  <div class="column col-6">
                    <q-btn
                      class="btn-grid-deletados"
                      stack
                      no-caps
                      label="Restaurar"
                      style="background: #189f2e; color: white"
                      icon="sym_o_done_outline"
                      @click="
                        (restaurarDialog = !restaurarDialog),
                          (linhaParaAcao = props.row)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th
            class="text-weight-bolder"
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
          >
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template #body-cell-selecionar="props">
        <q-td :props="props">
          <q-checkbox
            :disable="requisicao == 'deletados' || requisicao == 'finalizado'"
            v-model="selecionados"
            :val="props.row.id"
          />
        </q-td>
      </template>
      <template #body-cell-solicitante="props">
        <q-td :props="props">
          <span
            >{{ props.row?.plantiff?.name }} -
            {{ props.row?.plantiff?.sap || "" }}</span
          >
        </q-td>
      </template>
      <template #body-cell-centrodecusto="props">
        <q-td :props="props">
          <span>{{ props.row?.cost_center?.name }}</span>
        </q-td>
      </template>
      <template #body-cell-reservaSap="props">
        <q-td :props="props">
          <span>{{ props.row?.products[0]?.reserva_sap }}</span>
        </q-td>
      </template>

      <template #body-cell-produto="props">
        <q-td :props="props">
          <div v-for="(produto, index) in props.row.products" :key="index">
            <span
              v-if="
                produto.contracts[0] &&
                produto.contracts[0].pivot &&
                produto.contracts[0].pivot.contract_product_description
              "
              >{{ Math.trunc(produto.pivot.amount) }} x {{ produto.code }}

              {{
                produto.contracts[0].pivot.contract_product_description.substring(
                  0,
                  20
                ) + "..."
              }}</span
            >
            <q-tooltip
              v-if="
                produto.contracts[0] &&
                produto.contracts[0].pivot &&
                produto.contracts[0].pivot.contract_product_description
              "
              >{{ Math.trunc(produto.pivot.amount) }} x {{ produto.code }} -
              {{
                produto.contracts[0].pivot.contract_product_description
              }}</q-tooltip
            >
          </div>
        </q-td>
      </template>
      <template #body-cell-assinatura="props">
        <q-td :props="props">
          <q-img
            v-if="props.row.voucher_images.length != 0"
            :src="props.row.voucher_images[0].url"
            fit="contain"
            style="max-width: 30px; height: 45px"
          />
        </q-td>
      </template>
      <template #body-cell-criada="props">
        <q-td :props="props">
          <div class="column align">
            <span>{{
              props.row.created_at.split(" ")[0].split("-").reverse().join("/")
            }}</span>
            <span>{{ props.row.created_at.split(" ")[1] }}</span>
          </div>
        </q-td>
      </template>
      <template #body-cell-acoes="props">
        <q-td :props="props">
          <div v-if="requisicao != 'deletados'" class="row botoes">
            <q-icon
              v-if="requisicao != 'finalizado'"
              class="pointer"
              size="sm"
              color="positive"
              name="sym_o_done_outline"
              dense
              @click="
                requisicao == 'aprovacao'
                  ? (aprovarDialog = !aprovarDialog)(
                      (linhaParaAcao = props.row)
                    )
                  : handleFinalizarClick(props.row)
              "
            >
              <q-tooltip>Aprovar</q-tooltip>
            </q-icon>

            <q-icon
              v-if="requisicao == 'finalizado'"
              class="pointer"
              size="sm"
              style="color: #545454"
              name="content_copy"
              @click="
                (duplicarDialog = !duplicarDialog), (linhaParaAcao = props.row)
              "
            >
              <q-tooltip>Duplicar</q-tooltip>
            </q-icon>
            <router-link
              :to="{
                name: 'requisicao-detalhe',
                params: { requisicaoId: props.row.id },
                query: { userLogado: isUserLogado },
              }"
            >
              <q-icon
                class="pointer"
                size="sm"
                color="blue"
                name="sym_o_article"
              >
                <q-tooltip>Detalhe</q-tooltip>
              </q-icon>
            </router-link>
            <q-icon
              v-if="requisicao == 'finalizado'"
              class="pointer"
              size="sm"
              color="red"
              name="sym_o_delete"
              dense
              @click="
                (deletarDialog = !deletarDialog),
                  (linhaParaAcao = props.row),
                  (isFinalizado = true)
              "
            >
              <q-tooltip>Deletar</q-tooltip>
            </q-icon>
            <q-icon
              v-else
              class="pointer"
              size="sm"
              color="red"
              name="sym_o_delete"
              dense
              @click="
                (deletarDialog = !deletarDialog)((linhaParaAcao = props.row))
              "
            >
              <q-tooltip>Deletar</q-tooltip>
            </q-icon>

            <q-icon
              class="pointer"
              size="sm"
              color="black"
              name="sym_o_print"
              @click="imprimir(props.row.id)"
            >
              <q-tooltip>Imprimir</q-tooltip>
            </q-icon>
          </div>

          <div v-if="requisicao == 'deletados'" class="row botoes">
            <router-link
              :to="{
                name: 'requisicao-detalhe',
                params: { requisicaoId: props.row.id },
                query: { userLogado: isUserLogado },
              }"
            >
              <q-icon
                class="pointer"
                size="sm"
                color="blue"
                name="sym_o_article"
              >
                <q-tooltip>Detalhe</q-tooltip>
              </q-icon>
            </router-link>
            <q-icon
              @click="
                (restaurarDialog = !restaurarDialog),
                  (linhaParaAcao = props.row)
              "
              class="pointer"
              size="sm"
              color="positive"
              name="arrow_upward"
            >
              <q-tooltip>Restaurar</q-tooltip>
            </q-icon>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :direction-links="true"
        size="sm"
        :max-pages="6"
      />
    </div>

    <dialog-info-design
      mensagem="Aprovar Requisição?"
      subMensagem="Tem certeza que deseja aprovar a requisição?"
      :exibir="aprovarDialog"
      :showCancelar="true"
      @resultado="aprovar"
    />
    <dialog-info-design
      mensagem="Deletar Requisição?"
      subMensagem="Tem certeza que deseja deletar a requisição?"
      :exibir="deletarDialog"
      :showCancelar="true"
      @resultado="excluir"
    />
    <dialog-info-design
      mensagem="Aprovar Todas as Requisição?"
      subMensagem="Tem certeza que deseja aprovar todas as requisições selecionadas?"
      :exibir="aprovarTodasDialog"
      :showCancelar="true"
      @resultado="aprovarTodos"
    />
    <dialog-info-design
      mensagem="Rejeitar Todas as Requisição?"
      subMensagem="Tem certeza que deseja Rejeitar todas as requisições selecionadas?"
      :exibir="rejeitarTodasDialog"
      :showCancelar="true"
      @resultado="excluirTodos"
    />
    <dialog-info-design
      mensagem="Duplicar Requisição?"
      subMensagem="Tem certeza que deseja dulplicar a requisição selecionada?"
      :exibir="duplicarDialog"
      :showCancelar="true"
      @resultado="duplicarRequisicao"
    />
    <dialog-info-design
      mensagem="Restaurar Requisição?"
      subMensagem="Tem certeza que deseja restaurar a requisição selecionada?"
      :exibir="restaurarDialog"
      :showCancelar="true"
      @resultado="recuperarDeletado"
    />
    <dialog-info-design
      mensagem="Finalizar Requisição?"
      subMensagem="Tem certeza que deseja finalizar essa requisição?"
      :exibir="finalizarDialog"
      :showCancelar="true"
      @resultado="finalizarRequisicao"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";

export default {
  components: { DialogInfoDesign },
  props: {
    title: {
      type: String,
      default: "Sem titulo",
    },
    requisicao: {
      type: String,
      default: "aprovacao",
    },
    filtros: {
      type: Object,
      default: () => {},
    },
    atualizar: {
      type: Number,
      default: 0,
    },
    filtrar: {
      type: Boolean,
    },
    isUserLogado: {
      type: Boolean,
      default: false,
    },
  },
  // emits: ["recarregar"],
  setup(props, { emit }) {
    const columns = ref([
      {
        name: "selecionar",
        label: "Selecionar",
        field: (row) => row.id,
        align: "center",
        sortable: false,
      },
      {
        name: "id",
        label: "ID",
        field: (row) => row.id,
        align: "center",
        sortable: false,
      },
      {
        name: "reservaSap",
        label: "Reserva",
        field: "reservaSap",
        align: "center",
        sortable: false,
      },

      {
        name: "unidade",
        label: "Unidade",
        field: (row) => (row.vendor ? row.vendor.name : "Sem unidade"),
        align: "left",
        sortable: false,
      },
      {
        name: "solicitante",
        label: "Solicitante",
        field: (row) =>
          row.plantiff ? `${row.plantiff.name} - ${row.plantiff.sap}` : "",
        align: "left",
        sortable: false,
      },
      {
        name: "centrodecusto",
        label: "Centro de Custo",
        field: (row) => (row.cost_center ? row.cost_center.name : ""),
        align: "left",
        sortable: false,
      },
      {
        name: "produto",
        label: "Produtos",
        field: (row) => row.products,
        align: "left",
        sortable: false,
      },
      {
        name: "numprodutos",
        label: "N de Produtos",
        field: (row) => row.products.length,
        align: "left",
        sortable: false,
      },
      {
        name: "criada",
        label: "Criada",
        field: (row) =>
          row.created_at.split(" ")[0].split("-").reverse().join("/"),
        align: "center",
        sortable: false,
      },
      {
        name: "assinatura",
        label: "Assinatura",
        field: (row) =>
          row.created_at.split(" ")[0].split("-").reverse().join("/"),
        align: "left",
        sortable: false,
      },
      {
        name: "status",
        label: "Status Atual",
        field: (row) => row.status,
        align: "left",
        sortable: false,
      },
      {
        name: "acoes",
        label: "Ações",
        field: "acoes",
        align: "left",
        sortable: false,
      },
    ]);

    const store = useStore();
    const aprovarDialog = ref(false);
    const deletarDialog = ref(false);
    const aprovarTodasDialog = ref(false);
    const rejeitarTodasDialog = ref(false);
    const duplicarDialog = ref(false);
    const restaurarDialog = ref(false);
    const finalizarDialog = ref(false);
    const quantidade = ref("");
    const linhaParaAcao = ref(null);
    const isFinalizado = ref(false);
    const quasar = useQuasar();
    const table = ref("");
    const statusExport = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 50,
    });
    const selecionados = ref([]);
    const listaRequisicao = ref([]);
    const disable = ref(true);
    const router = useRouter();

    const listarRequisicoesPendentes = async (page = 1, rowsPerPage = 50) => {
      quasar.loading.show();
      // let data = new Date();
      try {
        disable.value = true;
        const response = await store.dispatch(
          props.isUserLogado
            ? "requisicao/listarUserLogado"
            : "requisicao/listar",
          {
            status: "pendente",
            per_page: rowsPerPage,
            current_page: page,
            id: props.filtros.nreq,
            cost_center_search: props.filtros.centro,
            plantiff_search: props.filtros.solicitante,
            vendor_id: await store.state.org.unidadeData.id,
            vendor_id_voucher: await store.state.org.unidadeData.id,
            categoria: props.filtros.intervalo.value,
            initial_date:
              props.filtros.dataInicial != ""
                ? props.filtros.dataInicial.split("/").reverse().join("-")
                : undefined,
            final_date: props.filtros.dataFinal
              ? props.filtros.dataFinal.split("/").reverse().join("-")
              : undefined,
          }
        );
        listaRequisicao.value = response.data.results.data;
        quantidade.value = response.data.results.total;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
        quasar.loading.hide();
        scrollUp();
      } catch (error) {
        quasar.loading.hide();
        console.log(error);
      }
    };

    let listarRequisicoesFinalizacao = async (page = 1, rowsPerPage = 50) => {
      quasar.loading.show();
      try {
        disable.value = true;
        let response = await store.dispatch(
          props.isUserLogado
            ? "requisicao/listarUserLogado"
            : "requisicao/listar",
          {
            status: "aprovado",
            per_page: rowsPerPage,
            current_page: page,
            id: props.filtros.nreq,
            cost_center_search: props.filtros.centro,
            plantiff_search: props.filtros.solicitante,
            vendor_id: await store.state.org.unidadeData.id,
            vendor_id_voucher: await store.state.org.unidadeData.id,
            categoria: props.filtros.intervalo.value,
            initial_date:
              props.filtros.dataInicial != ""
                ? props.filtros.dataInicial.split("/").reverse().join("-")
                : undefined,
            final_date: props.filtros.dataFinal
              ? props.filtros.dataFinal.split("/").reverse().join("-")
              : undefined,
          }
        );
        listaRequisicao.value = response.data.results.data;
        quantidade.value = response.data.results.total;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
        scrollUp();
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        console.log(error);
      }
    };

    let listarRequisicoesFinalizado = async (page = 1, rowsPerPage = 50) => {
      quasar.loading.show();
      disable.value = true;
      let response = await store.dispatch(
        props.isUserLogado
          ? "requisicao/listarUserLogado"
          : "requisicao/listar",
        {
          status: "finalizado",
          per_page: rowsPerPage,
          current_page: page,
          id: props.filtros.nreq,
          cost_center_search: props.filtros.centro,
          plantiff_search: props.filtros.solicitante,
          vendor_id: await store.state.org.unidadeData.id,
          vendor_id_voucher: await store.state.org.unidadeData.id,
          categoria: props.filtros.intervalo.value,
          initial_date:
            props.filtros.dataInicial != ""
              ? props.filtros.dataInicial.split("/").reverse().join("-")
              : undefined,
          final_date: props.filtros.dataFinal
            ? props.filtros.dataFinal.split("/").reverse().join("-")
            : undefined,
        }
      );

      listaRequisicao.value = response.data.results.data;
      quantidade.value = response.data.results.total;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.rowsNumber = response.data.results.total;
      pagination.value.page = response.data.results.current_page;
      disable.value = false;
      scrollUp();
      quasar.loading.hide();
    };

    let listarRequisicoesDeletado = async (page = 1, rowsPerPage = 50) => {
      quasar.loading.show();
      disable.value = true;
      let response = await store.dispatch(
        props.isUserLogado
          ? "requisicao/listarUserLogado"
          : "requisicao/listar",
        {
          somente_deletados: true,
          per_page: rowsPerPage,
          cost_center_search: props.filtros.centro,
          id: props.filtros.nreq,
          initial_date:
            props.filtros.dataInicial != ""
              ? props.filtros.dataInicial.split("/").reverse().join("-")
              : undefined,
          final_date: props.filtros.dataFinal
            ? props.filtros.dataFinal.split("/").reverse().join("-")
            : undefined,
          plantiff_search: props.filtros.listaUser
            ? store.state.autenticacao.usuarioLogado.id
            : props.filtros.solicitante,
          current_page: page,
          vendor_id: await store.state.org.unidadeData.id,
        }
      );

      listaRequisicao.value = response.data.results.data;
      quantidade.value = response.data.results.total;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.rowsNumber = response.data.results.total;
      pagination.value.page = response.data.results.current_page;
      disable.value = false;
      scrollUp();
      quasar.loading.hide();
    };

    const detalharRequisicao = (requisicaoId) => {
      router.push({
        name: "requisicao-detalhe",
        params: { requisicaoId: requisicaoId },
        query: { userLogado: props.isUserLogado },
      });
    };

    const verificarPermissaoTokenOnly = () => {
      const roles =
        store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles;

      const hasTokenPermission = roles.indexOf("voucher-auth-token") !== -1;

      const hasOtherAuthMethods =
        roles.indexOf("voucher-auth-assinatura") !== -1 ||
        roles.indexOf("voucher-auth-biometria") !== -1 ||
        roles.indexOf("voucher-auth-pin") !== -1 ||
        roles.indexOf("vouchers-auth-facial") !== -1;

      return hasTokenPermission && !hasOtherAuthMethods;
    };

    const handleFinalizarClick = (row) => {
      if (props.requisicao === "finalizacao" && verificarPermissaoTokenOnly()) {
        linhaParaAcao.value = row;
        finalizarDialog.value = true;
      } else {
        detalharRequisicao(row.id);
      }
    };

    const finalizarRequisicao = async (resultado) => {
      finalizarDialog.value = false;

      if (!resultado || !linhaParaAcao.value) {
        return;
      }

      try {
        quasar.loading.show();

        await store.dispatch("requisicao/finalizar", {
          reqId: linhaParaAcao.value.id,
          imagemBase64: store.state.autenticacao.token,
          idUsuario: linhaParaAcao.value.plantiff_id,
          date: gerarTimestamp(),
          batches: [],
          mensagem: undefined,
          auth_type: "token",
        });

        quasar.notify({
          message: "Requisição finalizada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });

        escolherRequisicao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message:
            error.response?.data?.message || "Erro ao finalizar requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      } finally {
        quasar.loading.hide();
        linhaParaAcao.value = null;
      }
    };

    const gerarTimestamp = () => {
      const dataAtual = new Date();

      const ano = dataAtual.getFullYear();
      const mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      const dia = dataAtual.getDate().toString().padStart(2, "0");
      const horas = dataAtual.getHours().toString().padStart(2, "0");
      const minutos = dataAtual.getMinutes().toString().padStart(2, "0");
      const segundos = dataAtual.getSeconds().toString().padStart(2, "0");

      const timestamp = `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;

      return timestamp;
    };

    const escolherRequisicao = async () => {
      if (props.filtrar == false || props.filtrar == undefined) {
        return;
      }
      store.dispatch("pdt/hiddenHeader", true);
      if (props.requisicao == "aprovacao") {
        statusExport.value = "Pendente";
        listarRequisicoesPendentes();
      } else if (props.requisicao == "finalizacao") {
        statusExport.value = "Aprovado";
        listarRequisicoesFinalizacao();
      } else if (props.requisicao == "deletados") {
        statusExport.value = undefined;
        listarRequisicoesDeletado();
      } else if (props.requisicao == "finalizado") {
        statusExport.value = "finalizado";
        listarRequisicoesFinalizado();
      }
    };

    const handleRequest = async () => {
      if (props.requisicao == "aprovacao") {
        listarRequisicoesPendentes(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      } else if (props.requisicao == "finalizacao") {
        listarRequisicoesFinalizacao(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      } else if (props.requisicao == "deletados") {
        listarRequisicoesDeletado(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      } else if (props.requisicao == "finalizado") {
        listarRequisicoesFinalizado(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    };

    const aprovar = async (resultado) => {
      aprovarDialog.value = false;
      if (resultado) {
        try {
          await store.dispatch("requisicao/aprovar", {
            reqId: linhaParaAcao.value.id,
          });
          escolherRequisicao();
          quasar.notify({
            message: "Requisição aprovada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          quasar.notify({
            message: "Erro ao aprovar requisição",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const excluir = async (resultado) => {
      deletarDialog.value = false;
      if (resultado) {
        try {
          if (isFinalizado.value) {
            await store.dispatch("requisicao/excluirFinalizado", {
              voucher_id: linhaParaAcao.value.id,
            });
          } else {
            await store.dispatch("requisicao/excluir", {
              reqId: linhaParaAcao.value.id,
            });
          }

          setTimeout(() => {
            escolherRequisicao();
          }, 500);
          quasar.notify({
            message: "Requisição excluida com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          console.log(error);
          quasar.notify({
            message: "Erro ao excluir requisição",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const aprovarTodos = async (resultado) => {
      aprovarTodasDialog.value = false;
      if (resultado) {
        selecionados.value.forEach(async (e) => {
          try {
            await store.dispatch("requisicao/aprovar", {
              reqId: e,
            });
            setTimeout(() => {
              escolherRequisicao();
            }, 500);

            quasar.notify({
              message: "Requisição aprovada com sucesso",
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } catch (error) {
            quasar.notify({
              message: `${error.response.data.message}`,
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        });
        selecionados.value = [];
      }
    };

    const excluirTodos = async (resultado) => {
      rejeitarTodasDialog.value = false;
      if (resultado) {
        try {
          selecionados.value.forEach(async (e) => {
            await store.dispatch("requisicao/excluir", {
              reqId: e,
            });
          });

          escolherRequisicao();
          quasar.notify({
            message: "Requisição excluida com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          quasar.notify({
            message: "Erro ao excluir requisição",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        selecionados.value = [];
      }
    };

    const recuperarDeletado = async (resultado) => {
      restaurarDialog.value = false;
      if (linhaParaAcao.value.status == "Cancelado") {
        quasar.notify({
          message: "Requisição cancelada não pode ser recuperada",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (resultado) {
        try {
          await store.dispatch("requisicao/recuperarDeletado", {
            reqId: linhaParaAcao.value.id,
          });

          escolherRequisicao();
          quasar.notify({
            message: "Requisição recuperada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          console.log(error);
          quasar.notify({
            message: "Erro ao recuperar requisição",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch(
          props.isUserLogado
            ? "requisicao/exportarUserLogado"
            : "requisicao/exportar",
          {
            vendor_id: await store.state.org.unidadeData.id,
            vendor_id_voucher: await store.state.org.unidadeData.id,
            status: statusExport.value,
            cost_center: props.filtros.centro,
          }
        );
        quasar.notify({
          message:
            "Dados exportados com sucesso você recebera o link para dawnload em seu e-mail",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao exportar dados",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const duplicarRequisicao = async (resultado) => {
      duplicarDialog.value = false;
      if (resultado) {
        let produtosLista = [];
        linhaParaAcao.value.products.forEach((produto) => {
          produtosLista.push({
            id: produto.id,
            amount: produto.pivot.amount,
          });
        });

        try {
          let response = await store.dispatch("requisicao/criarRequisicao", {
            cost_center_id: linhaParaAcao.value.cost_center.id,
            description: `Cópia requisição número ${linhaParaAcao.value.id}`,
            plantiff_id: linhaParaAcao.value.plantiff_id,
            products: produtosLista,
            vendor_id: linhaParaAcao.value.vendor_id,
          });
          let id = response.data.model.id;
          quasar.notify({
            message: "Requisição duplicada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          emit("recarregar");
          router.push({
            name: "requisicao-detalhe",
            params: { requisicaoId: id },
            query: { userLogado: props.isUserLogado },
          });
        } catch (error) {
          console.log(error);
          quasar.notify({
            message: "Erro ao duplicar Requisição",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const scrollUp = () => {
      table.value.scrollTo(0);
    };

    const imprimir = async (id) => {
      const routeData = router.resolve({
        name: "requisicao-imprimir",
        params: { requisicaoId: id },
      });
      window.open(routeData.href, "_blank");
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.filtrar,
      () => {
        escolherRequisicao();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        escolherRequisicao();
      }
    );

    onMounted(() => {
      escolherRequisicao();
    });

    if (
      store.state.autenticacao.cliente[0] != "cerradinho" &&
      store.state.autenticacao.cliente[0] != "staging-cerradinho"
    ) {
      columns.value = columns.value.filter((value) => {
        if (value.name != "reservaSap") {
          return value;
        }
      });
    }

    return {
      aprovarTodos,
      columns,
      listaRequisicao,
      pagination,
      listarRequisicoesPendentes,
      table,
      listarRequisicoesFinalizacao,
      listarRequisicoesDeletado,
      listarRequisicoesFinalizado,
      quantidade,
      disable,
      exportar,
      scrollUp,
      excluirTodos,
      isFinalizado,
      imprimir,
      aprovar,
      excluir,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selecionados,
      handleRequest,
      recuperarDeletado,
      detalharRequisicao,
      duplicarRequisicao,
      aprovarDialog,
      deletarDialog,
      aprovarTodasDialog,
      rejeitarTodasDialog,
      duplicarDialog,
      restaurarDialog,
      finalizarDialog,
      linhaParaAcao,
      handleFinalizarClick,
      finalizarRequisicao,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 900px;
}
.input {
  width: 180px;
}
.my-sticky-dynamic {
  max-height: 500px;
  overflow-y: scroll;
}
.pointer {
  cursor: pointer;
}

.produto-class div {
  width: 300px;
}
.botoes {
  flex-wrap: nowrap !important;
}

.align {
  align-items: center;
}
tbody tr td {
  white-space: pre-wrap;
}
@media only screen and (max-width: 635px) {
  .respI {
    padding: 5px 6px 5px 6px;
    margin: 10px 8px 40px 0px;
    font-size: 12px;
  }
  .btn-imprimir {
    padding: 5px 6px 5px 6px;
    font-size: 12px;
  }
  .btn-container {
    padding: 0;
  }
  .texto-titulo {
    font-size: 14px;
  }
  .text-grid-table {
    font-size: 10px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }

  .btn-grid-container {
    padding: 0;
    margin: 0;
  }
  .btn-grid-finalizacao {
    font-size: 12px;
    border-radius: 0px;
  }
  .elipse {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .titulo-input-status {
    margin: 0;
    padding: 0;
  }
  .status-elipse-container {
    margin-bottom: 3px;
  }
  .btn-grid-deletados {
    font-size: 12px;
    border-radius: 0px;
  }
}
@media only screen and (max-width: 380px) {
  .respI {
    padding: 5px 6px 5px 6px;
    margin: 10px 8px 40px 0px;
    font-size: 11px;
  }
}
</style>
